import { Component } from '@angular/core';

import { AppSettingsService } from '~/core/services/appsettings.service';
import { AppSettings } from '~/core/models/appsettings';

@Component({
    selector: 'access',
    templateUrl: './access.component.html',
    styleUrls: ['./access.component.scss'],
    standalone: false
})

export class AccessComponent {
    private appSettings: AppSettings = new AppSettings();

    public title: string = "";
    public type: string = "application";
    public supportLink = "";

    constructor(
        private appSettingsService: AppSettingsService
    ) { }

    //*************************************************************************
    //  Component Life-Cycle Methods
    //*************************************************************************
    public async ngOnInit() {
		if (window.history.state.type && window.history.state.type !== "") {
			this.type = window.history.state.type;
		}

        this.appSettings = await this.appSettingsService.getSettings();

        this.title = this.appSettings.title;
        this.supportLink = this.appSettings.supportLink;
    }
}
